'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { recordarOrigen } from '@/lib/anuncio-origen';

/**
 * Guarda de qué anuncio vino el visitante, en cuanto llega.
 *
 * Los ids de campaña/conjunto/anuncio sólo están en la URL de ENTRADA: los pone
 * Meta al sustituir las macros del anuncio. Si el visitante mira tres autos
 * antes de escribir, la URL del formulario ya no los tiene y el lead queda sin
 * atribuir aunque el clic haya sido pago.
 *
 * ── Por qué también mira las navegaciones ─────────────────────────────────
 *
 * Porque el clic puede entrar por cualquier ruta —la ficha de un auto, el
 * catálogo— y porque el router puede cambiar la URL sin recargar. Guardar sólo
 * al montar perdería el caso de volver a entrar por otro anuncio en la misma
 * pestaña. Una URL sin parámetros no borra nada, así que navegar por el sitio
 * después de llegar es inofensivo.
 *
 * NO va gateado por consentimiento de cookies, y es deliberado: esto no es
 * seguimiento publicitario ni perfilado. Es el origen de una consulta que la
 * persona está a punto de enviar por su propia voluntad, igual que quedaría
 * registrado "entró por el formulario de financiamiento". Vive en la pestaña y
 * se va con ella.
 */
export function AnuncioOrigenTracker() {
  const pathname = usePathname();

  useEffect(() => {
    try {
      recordarOrigen(window.location.href);
    } catch {
      // Nunca puede tumbar la página: es un dato de medición.
    }
  }, [pathname]);

  return null;
}
